<div class="label-group">
  <label class="label" id="labelGroup_label">{{title}}</label>
  <div *ngIf="data">
      <span id="labelGroup_Data">{{data}}</span>
  </div>
  <div *ngIf="multilineData" class="multiline-data">
    <div id="labelGroup_Multiline" *ngFor="let line of multilineData">
      <span>{{line}}</span>
    </div>
  </div>
</div>
